import React from "react";
import PropTypes from "prop-types";
import {Provider} from "react-redux";
import axios from 'axios'
import axiosRetry from 'axios-retry'
import isRetryAllowed from 'is-retry-allowed';
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createGenerateClassName,
  jssPreset
} from "@material-ui/core/styles";
import {create} from 'jss';
import createStoreForSSR from "./store";
import Router from "../common/Router";
import Root from "./components/Root";
import {Route} from "react-router-dom";
import MobileCtx from "../../contexts/MobileCtx";
import DictionaryCtx from "../../contexts/DictionaryCtx";
import dictionary from "../../dictionary";
import ProductsCtx from "./contexts/ProductsCtx";
import ColorHexMapCtx from "./contexts/ColorHexMapCtx";
import {getMuiTheme} from "../../../javascripts/getMaterialTheme";

axiosRetry(axios, {
  retries: 2,
  retryDelay: (retryCount) => retryCount * 500,
  retryCondition: (error) => {
    return (
      error.code !== 'ECONNABORTED' &&
      (!error.response || (error.response.status >= 400 && error.response.status <= 599)) &&
      isRetryAllowed(error)
    );
  }
})

class App extends React.Component {
  static propTypes = {
    materialUI: PropTypes.string,
    state: PropTypes.shape({
      path: PropTypes.string,
      isMobile: PropTypes.bool,
      isPichshop: PropTypes.bool,
      products: PropTypes.array,
      product: PropTypes.object,
      condition: PropTypes.object,
      initialVariants: PropTypes.object,
      designs: PropTypes.object,
      colorHexMap: PropTypes.object,
      pictures: PropTypes.object,
      crops: PropTypes.array,
      figures: PropTypes.array,
      emoji: PropTypes.object,
      cliparts: PropTypes.object,
      letterings: PropTypes.array,
      user: PropTypes.object,
      authenticityToken: PropTypes.string,
      onPlatform: PropTypes.string,
      shutterStockEnabled: PropTypes.bool,
      mobileApp: PropTypes.bool
    })
  };
  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = document.getElementById(
      `jss-server-side-${this.props.materialUI}`
    );
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
    document
      .querySelector(`[data-react-class]`)
      .removeAttribute(`data-react-props`);
  }
  render() {
    const {
      path,
      isMobile,
      isPichshop,
      products,
      product,
      designs,
      condition,
      initialVariants,
      colorHexMap,
      pictures,
      authenticityToken,
      crops,
      figures,
      emoji,
      cliparts,
      letterings,
      user,
      onPlatform,
      shutterStockEnabled,
      mobileApp,
      currency
    } = this.props.state;
    const sides = {};
    const realism = {};
    const message = {};
    const uploader = {};
    const undoRedo = {};
    const isShownProducts = false;
    const initialStore = {
      path,
      product,
      designs,
      condition,
      sides,
      realism,
      message,
      pictures,
      uploader,
      undoRedo,
      authenticityToken,
      isShownProducts,
      crops,
      isPichshop,
      figures,
      emoji,
      cliparts,
      letterings,
      initialVariants,
      user,
      forAllSides: true,
      onPlatform,
      shutterStockEnabled,
      mobileApp,
      drawControlPopup: '',
      currency,
      isMobile,
    };
    const store = createStoreForSSR(initialStore);
    const theme = getMuiTheme(onPlatform);
    // Create a new class name generator.
    const generateClassName = createGenerateClassName({
      productionPrefix: `${this.props.materialUI}-react-app`
    });
    const jss = create({
      ...jssPreset(),
      // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
      insertionPoint: typeof document !== 'undefined' && document.getElementById('jss-insertion-point'),
    });

    return (
      <Provider store={store}>
        <Router path={path}>
          <Route
            path="/"
            render={(props) => (
              <MobileCtx.Provider value={isMobile}>
                <DictionaryCtx.Provider value={dictionary.editor}>
                  <ProductsCtx.Provider value={products}>
                    <ColorHexMapCtx.Provider value={colorHexMap}>
                      <JssProvider jss={jss} generateClassName={generateClassName}>
                        <MuiThemeProvider theme={theme}>
                          <Root {...props} />
                        </MuiThemeProvider>
                      </JssProvider>
                    </ColorHexMapCtx.Provider>
                  </ProductsCtx.Provider>
                </DictionaryCtx.Provider>
              </MobileCtx.Provider>
            )}
          />
        </Router>
      </Provider>
    );
  }
}

export default App;
